import { sortBy } from 'es-toolkit/compat';

import {
  RequestableState,
  createRequestableState,
  handleDone,
  handleFailed,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { core } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

interface State {
  isInitialized: boolean;
  businessGroups: core.BusinessGroupInternal[];
  businessGroup: RequestableState<core.BusinessGroupInternal>;
}

const initialState: State = {
  isInitialized: false,
  businessGroups: [],
  businessGroup: createRequestableState<core.BusinessGroupInternal>(),
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type } = action;
  switch (type) {
    case ClowncarAppConstants.BUSINESS_GROUPS_FETCH_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.BUSINESS_GROUPS_FETCH_DONE: {
      return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        businessGroups: sortBy(action.payload as any[], (businessGroup) => businessGroup.name),
        isInitialized: true,
      };
    }
    case ClowncarAppConstants.BUSINESS_GROUP_FETCH_STARTING: {
      return {
        ...state,
        businessGroup: handleStarting(state.businessGroup, action),
      };
    }
    case ClowncarAppConstants.BUSINESS_GROUP_FETCH_DONE: {
      return {
        ...state,
        businessGroup: handleDone(state.businessGroup, action),
      };
    }
    case ClowncarAppConstants.BUSINESS_GROUP_FETCH_FAILED: {
      return {
        ...state,
        businessGroup: handleFailed(state.businessGroup, action),
      };
    }
    default:
      return state;
  }
}
